import React from 'react';
import NavBarSub from '../layout/NavBarSub';
import SubAbout from '../layout/SubAbout';
import AboutContent from '../layout/AboutContent';
import OurPeople from '../layout/OurPeople';

const About = () => {
  return (
    <>
      <NavBarSub />
      <SubAbout />
      <AboutContent />
      <OurPeople />
    </>
  );
};

export default About;
